import { DropdownItem, DropdownItemProps } from 'bold-ui'
import { Link, LinkProps } from 'react-router-dom'

export interface DropdownLinkProps extends DropdownItemProps, Pick<LinkProps, 'to' | 'replace' | 'innerRef'> {}

export const DropdownLink = (props: DropdownLinkProps) => {
  const { disabled, to, ...rest } = props

  const component = disabled ? 'li' : Link

  return <DropdownItem component={component} disabled={disabled} to={!disabled ? to : undefined} {...rest} />
}
